import React, { useState, useEffect } from "react";
import axios from "axios";
// import Wifi from "../../../assets/icons/wifi.png";
import "./styles.css";

const CardInternet = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiImg = process.env.REACT_APP_API_IMG;

  const [postagens, setPostagens] = useState([]);
  const [postagemFotos, setPostagemFotos] = useState({});

  const TextRender = ({ htmlContent }) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  };

  useEffect(() => {
    fetchPostagens();
  }, []);

  const fetchPostagens = async () => {
    try {
      const response = await axios.get(`${apiUrl}/postagens`);
      const posts = response.data || [];
      setPostagens(posts);

      const fotos = {};

      await Promise.all(
        posts.map(async (postagem) => {
          const res = await axios.get(`${apiUrl}/fotos/${postagem._id}`);
          fotos[postagem._id] = (res.data || []).map((foto) => ({
            ...foto,
            url: `${apiImg}/assets/fotos/${foto.foto}`,
          }));
        })
      );

      setPostagemFotos(fotos);
    } catch (error) {
      console.error("Erro ao buscar as postagens e fotos:", error);
    }
  };

  return (
    <div className="container body-post">
      {postagens.map((postagem) => {
        const fotos = postagemFotos[postagem._id] || [];

        return (
          <div key={postagem._id} className="postagem-card">
            <div className="row justify-content-center">
              <div className="col-12 postagem-body">
                {/* <div className="title-img-wifi">
                  <img src={Wifi} alt="wifi" />
                </div> */}

                <div className="postagem-content">
                  <h2>{postagem.title}</h2>
                  {postagem.sub && <h3>{postagem.sub}</h3>}
                  <TextRender htmlContent={postagem.text} />
                </div>
              </div>
            </div>

            {fotos.length > 0 && (
              <div className="row g-3 postagem-galeria justify-content-center">
                {fotos.map((foto) => (
                  <div
                    key={foto._id}
                    className="col-12 col-sm-6 col-lg-4 col-xl-3"
                  >
                    <div className="foto-postagem">
                      <img src={foto.url} alt={postagem.title || "Postagem"} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}

      {postagens.length > 0 && (
        <>
          <div className="row">
            <div className="col-12">
              <span className="postagem-aviso">
                * Valor promocional válido somente para pagamentos até a data do
                vencimento.
              </span>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="buttons">
                <a href="/internet" className="btn-hover color-7">
                  Saiba mais...
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CardInternet;